var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInvite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3545 8.08156C14.3091 8.08156 15.9909 6.30213 15.9909 3.98517C15.9909 1.69601 14.3 0 12.3545 0C10.4182 0 8.71818 1.73309 8.72727 4.00371C8.72727 6.30213 10.4091 8.08156 12.3545 8.08156ZM12.3545 9.7405C10.8 9.7405 9.44545 10.1112 8.34545 10.6858C9.65454 11.7794 10.4909 13.4384 10.4909 15.2919C10.4909 15.7553 10.4364 16.228 10.3273 16.6636H18.0636C19.4909 16.6636 20 16.2465 20 15.431C20 13.0399 17.0636 9.7405 12.3545 9.7405ZM4.61818 20C7.12727 20 9.23636 17.8591 9.23636 15.2919C9.23636 12.7062 7.15455 10.5839 4.61818 10.5839C2.09091 10.5839 0 12.7062 0 15.2919C0 17.8777 2.09091 20 4.61818 20ZM4.62727 18.3503C4.30909 18.3503 4.02727 18.1279 4.02727 17.7757V15.8573H2.29091C1.98182 15.8573 1.72727 15.5978 1.72727 15.2919C1.72727 14.9768 1.98182 14.7173 2.29091 14.7173H4.02727V12.7989C4.02727 12.4467 4.30909 12.2336 4.62727 12.2336C4.93636 12.2336 5.21818 12.4467 5.21818 12.7989V14.7173H6.95455C7.26364 14.7173 7.50909 14.9768 7.50909 15.2919C7.50909 15.5978 7.26364 15.8573 6.95455 15.8573H5.21818V17.7757C5.21818 18.1279 4.93636 18.3503 4.62727 18.3503Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInvite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-invite.5e63ba2b43f92a751680dba032df4717.svg";